
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/corporate-bookings",
      function () {
        return require("private-next-pages/corporate-bookings.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/corporate-bookings"])
      });
    }
  